// stats-service stores durations in seconds - use ms in app for consistency across codebase
export default function transformServerSessionDuration(
  serverSessionDuration: number
): number {
  return serverSessionDuration * 1000;
}
